//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validatePass, typeOptions, statusOptions, validatePhone } from './common';
const defaultInfo = {
  name: '',
  account: '',
  password: '',
  phone: '',
  email: '',
  introduce: '',
  type: '',
  unionid: '',
  status: '',
  app_infos: [],
};
const typeList = { 1: '订阅号', 2: '服务号', 3: '小程序', 4: '腾会应用', 5: '企业微信' };
export default {
  filters: {
    getType(value) {
      return typeList[value] || value;
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'view', // view: 查看 ,create: 创建, update: 更新
    },
    uin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusOptions,
      typeList,
      loading: false,
      form: JSON.parse(JSON.stringify(defaultInfo)),
      // 类型
      typeOptions,
      rules: {
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        type: [{ required: true, message: '请选择账号类型', trigger: 'blur' }],
        password: [
          {
            validator: validatePass,
            trigger: 'change',
          },
        ],
        app_infos: [
          {
            validator: (rule, value, callback) => {
              if (
                value.some((item) => {
                  return item.appid === '';
                })
              ) {
                callback(new Error('请填写完整信息'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) {
          this.$emit('cancel', false);
        }
      },
    },
    title() {
      switch (this.type) {
        case 'view':
          return '账号详情';
        case 'create':
          return '创建账号';
        case 'update':
          return '更新账号信息';
        default:
          return '账号详情';
      }
    },
  },
  created() {
    if (['view', 'update'].includes(this.type)) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      this.loading = true;
      try {
        const res = await this.$request({
          url: this.$api.AccountGetUserInfo,
          data: { uin: this.uin },
        });
        this.form = res;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    addApp() {
      this.form.app_infos.push({
        appid: '',
        openid: '',
        type: '',
        userid: '',
        haveDel: undefined,
      });
    },
    delApp(index) {
      this.form.app_infos.splice(index, 1);
    },
    close() {
      this.form = JSON.parse(JSON.stringify(defaultInfo));
      this.$refs.form.resetFields();
      this.visible = false;
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$request({
              url: this.$api.UpdateLoginAccount,
              data: {
                ...this.form,
                uin: undefined,
                create_state: this.type === 'create' ? 1 : 2, // 1-新建 2-修改
              },
            });
            res?.msg && this.$message.error(res.msg);
            this.$emit('refresh');
          } catch (err) {
            console.log(err);
          }
        }
      });
    },
  },
};
